export const base_image_url = "https://static.renderg.com:6443/renderg_dist";